import { apiClient } from "../../../lib/apiClient";
import type { ApiResponse } from "../../../types/apiResponse";
import type { TemplatePDF } from "../types/template";

export const fetchTemplatesByType = async (type: 'contract' | 'bill'): Promise<ApiResponse<TemplatePDF[]>> => {
  return apiClient<ApiResponse<TemplatePDF[]>>(`/v1/catalogs/templates/${type}`, {
    method: "GET"
  });
};
